import { render } from "./CRMAgentView.vue?vue&type=template&id=42db0fa5"
import script from "./CRMAgentView.vue?vue&type=script&lang=js"
export * from "./CRMAgentView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__